export default __webpack_public_path__ + "static/media/03e_fold-17.f6ee71a6.mp4";